export enum AccountError {
  AccountAlreadyConfirmed = 1,
  AccountError = 2,
}
